<script setup lang="ts">
import { useModalStore } from './modal-store';
import ModalV2 from './ModalV2.vue';

const modalStore = useModalStore();
</script>

<template>
  <div v-for="modal in modalStore.modals.value" :key="modal.id">
    <ModalV2 :modal="modal" />
  </div>
</template>
